/* src/app/builder-screen-beta/builder-screen.component.scss */
.builder-screen-root {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: #f5f5f5;
}
.builder-screen-root[data-screen-size=mobile] {
  padding-top: 0;
  padding-bottom: 80px;
}
.builder-workspace {
  display: grid;
  flex: 1;
  gap: 12px;
  padding: 12px;
  overflow: hidden;
  grid-template-areas: "palette canvas inspector" "json json json";
  grid-template-columns: 220px 1fr 320px;
  grid-template-rows: 1fr auto;
}
.builder-workspace:has(.inspector-section.legacy.hidden) {
  grid-template-areas: "palette canvas canvas" "json json json";
  grid-template-columns: 220px 1fr;
}
.builder-workspace:has(.palette-section.collapsed) {
  grid-template-columns: 60px 1fr 320px;
}
.builder-workspace:has(.inspector-section.collapsed) {
  grid-template-columns: 220px 1fr 60px;
}
.builder-workspace:has(.palette-section.collapsed):has(.inspector-section.collapsed) {
  grid-template-columns: 60px 1fr 60px;
}
.builder-workspace.preview-mode .section-header {
  display: none;
}
.builder-workspace.preview-mode .canvas-container {
  border: none;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
@media (max-width: 1199px) and (min-width: 768px) {
  .builder-workspace {
    grid-template-areas: "palette canvas" "inspector inspector" "json json";
    grid-template-columns: 200px 1fr;
    grid-template-rows: 1fr auto auto;
    gap: 8px;
    padding: 8px;
  }
}
@media (max-width: 767px) {
  .builder-workspace {
    grid-template-areas: "canvas" "json";
    grid-template-columns: 1fr;
    grid-template-rows: 1fr auto;
    gap: 8px;
    padding: 8px;
  }
  .builder-workspace .palette-section,
  .builder-workspace .inspector-section {
    display: none;
  }
}
.palette-section {
  grid-area: palette;
  background: white;
  border-radius: 8px;
  border: 1px solid #e8e8e8;
  overflow: hidden;
  transition: all 0.3s ease;
  min-height: 400px;
  display: flex;
  flex-direction: column;
}
.palette-section .section-content {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0;
  padding: 0;
}
.palette-section.collapsed {
  min-width: 60px;
  max-width: 60px;
  width: 60px;
  overflow: visible;
}
.palette-section.collapsed .section-content {
  display: none;
}
.palette-section.collapsed .section-header {
  flex-direction: column;
  padding: 12px 8px;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  min-height: auto;
  height: auto;
  flex: 0 0 auto;
  border-bottom: none;
}
.palette-section.collapsed .section-header h3 {
  writing-mode: vertical-rl;
  text-orientation: mixed;
  margin: 0;
  white-space: nowrap;
  font-size: 12px;
  font-weight: 600;
  -webkit-user-select: none;
  user-select: none;
  letter-spacing: 0.5px;
  color: #595959;
  flex: 1;
}
.palette-section.collapsed .section-header button {
  transform: rotate(0deg);
  flex-shrink: 0;
}
.palette-section.collapsed .section-header button:hover {
  background: #e8f4ff;
  color: #1890ff;
}
.canvas-section {
  grid-area: canvas;
  background: white;
  border-radius: 8px;
  border: 1px solid #e8e8e8;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.inspector-section {
  grid-area: inspector;
  background: white;
  border-radius: 8px;
  border: 1px solid #e8e8e8;
  overflow: hidden;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 140px);
}
.inspector-section .section-content {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0;
  padding: 8px;
}
.inspector-section.legacy.hidden {
  display: none;
}
.inspector-section.collapsed {
  min-width: 60px;
  max-width: 60px;
  width: 60px;
  overflow: visible;
}
.inspector-section.collapsed .section-content {
  display: none;
}
.inspector-section.collapsed .section-header {
  flex-direction: column;
  padding: 12px 8px;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  min-height: auto;
  height: auto;
  flex: 0 0 auto;
  border-bottom: none;
}
.inspector-section.collapsed .section-header h3 {
  writing-mode: vertical-rl;
  text-orientation: mixed;
  margin: 0;
  white-space: nowrap;
  font-size: 12px;
  font-weight: 600;
  -webkit-user-select: none;
  user-select: none;
  letter-spacing: 0.5px;
  color: #595959;
  flex: 1;
}
.inspector-section.collapsed .section-header button {
  transform: rotate(0deg);
  flex-shrink: 0;
}
.inspector-section.collapsed .section-header button:hover {
  background: #e8f4ff;
  color: #1890ff;
}
.json-section {
  grid-area: json;
  background: white;
  border-radius: 8px;
  border: 1px solid #e8e8e8;
  overflow: visible;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
}
.json-section.collapsed {
  max-height: 48px;
}
.json-section.collapsed .section-content {
  display: none;
}
.section-header {
  background: #fafafa;
  border-bottom: 1px solid #e8e8e8;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 48px;
  transition: all 0.3s ease;
}
.section-header h3 {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: #262626;
  transition: all 0.3s ease;
}
.section-header .canvas-controls {
  display: flex;
  align-items: center;
  gap: 4px;
}
.section-header .canvas-controls :host ::ng-deep .ant-btn.active {
  background: #e6f7ff;
  border-color: #91d5ff;
  color: #1890ff;
}
.section-content {
  flex: 1;
  overflow: auto;
  min-height: 0;
}
.section-content:not(.canvas-container) {
  padding: 8px;
}
.json-section .section-content {
  padding: 0;
}
.section-content.canvas-container {
  overflow: visible;
}
.inspector-section .section-content {
  overflow: hidden;
  padding: 0;
  height: 100%;
}
.section-content.hidden {
  display: none;
}
.section-content::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
.section-content::-webkit-scrollbar-track {
  background: #f5f5f5;
  border-radius: 4px;
}
.section-content::-webkit-scrollbar-thumb {
  background: #d9d9d9;
  border-radius: 4px;
}
.section-content::-webkit-scrollbar-thumb:hover {
  background: #bfbfbf;
}
.section-content::-webkit-scrollbar-corner {
  background: #f5f5f5;
}
.section-content.canvas-container {
  position: relative;
  background: #fafafa;
  border: 1px dashed #d9d9d9;
  margin: 8px;
  border-radius: 4px;
  transform-origin: top left;
  transition: transform 0.2s ease;
}
.section-content.canvas-container.grid-visible {
  background-image:
    linear-gradient(rgba(0, 0, 0, 0.1) 1px, transparent 1px),
    linear-gradient(
      90deg,
      rgba(0, 0, 0, 0.1) 1px,
      transparent 1px);
  background-size: 20px 20px;
}
.save-controls-bar {
  display: none;
}
.builder-content {
  display: none;
}
.panel {
  display: none;
}
@media (max-width: 1199px) and (min-width: 768px) {
  .section-header {
    padding: 10px 12px;
    min-height: 44px;
  }
  .section-header h3 {
    font-size: 13px;
  }
}
@media (max-width: 767px) {
  .builder-screen-root {
    padding-top: 0;
  }
  .section-header {
    padding: 12px 16px;
  }
  .section-header h3 {
    font-size: 16px;
  }
  .section-content.canvas-container {
    margin: 12px;
  }
}
.palette-section,
.inspector-section,
.json-section {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
@media (prefers-contrast: high) {
  .builder-workspace {
    background: white;
  }
  .section-header {
    background: #f0f0f0;
    border-bottom: 2px solid #000;
  }
  .palette-section,
  .canvas-section,
  .inspector-section,
  .json-section {
    border: 2px solid #000;
  }
}
@media (prefers-reduced-motion: reduce) {
  .palette-section,
  .inspector-section,
  .json-section,
  .section-content.canvas-container {
    transition: none;
  }
}
::ng-deep .builder-screen-root nz-tabs,
::ng-deep .builder-screen-root .ant-tabs,
::ng-deep .builder-screen-root .ant-tabs-nav,
::ng-deep .builder-screen-root .ant-tabs-nav-wrap,
::ng-deep .builder-screen-root .ant-tabs-tab {
  position: relative;
  z-index: 10 !important;
}
::ng-deep .builder-screen-root .ant-tabs-content,
::ng-deep .builder-screen-root .ant-tabs-tabpane {
  position: relative;
  z-index: 8;
}
.json-section {
  border-top: 1px solid #f0f0f0;
}
.json-section .section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  background: #fafafa;
  border-bottom: 1px solid #f0f0f0;
}
.json-section .section-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #262626;
}
.json-section .section-header button {
  color: #8c8c8c;
}
.json-section .section-header button:hover {
  color: #1890ff;
}
.json-section .section-content {
  padding: 24px;
  transition: all 0.3s ease;
}
.json-section .section-content.hidden {
  display: none;
}
.json-section.collapsed .section-content {
  display: none;
}
.template-selector-section {
  border-top: 1px solid #f0f0f0;
}
.template-selector-section .section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  background: #fafafa;
  border-bottom: 1px solid #f0f0f0;
}
.template-selector-section .section-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #262626;
}
.template-selector-section .section-header button {
  color: #8c8c8c;
}
.template-selector-section .section-header button:hover {
  color: #1890ff;
}
.template-selector-section .section-content {
  padding: 24px;
  transition: all 0.3s ease;
}
.template-selector-section .section-content.hidden {
  display: none;
}
.template-selector-section.collapsed .section-content {
  display: none;
}
.template-manager-content {
  padding: 16px;
}
.template-manager-content .manager-header {
  margin-bottom: 24px;
  text-align: center;
}
.template-manager-content .saved-templates-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.template-manager-content .saved-templates-list .template-item {
  transition: all 0.3s ease;
}
.template-manager-content .saved-templates-list .template-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
.template-manager-content .saved-templates-list .template-item .template-info h4 {
  margin: 0 0 8px 0;
  font-size: 16px;
  font-weight: 600;
  color: #262626;
}
.template-manager-content .saved-templates-list .template-item .template-info .description {
  font-size: 14px;
  color: #8c8c8c;
  margin-bottom: 12px;
  min-height: 40px;
}
.template-manager-content .saved-templates-list .template-item .template-info .template-meta {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
}
.template-manager-content .saved-templates-list .template-item .template-info .template-meta .component-count {
  font-size: 12px;
  color: #8c8c8c;
  display: flex;
  align-items: center;
  gap: 4px;
}
.template-manager-content .saved-templates-list .template-item .template-info .template-dates {
  font-size: 12px;
  color: #bfbfbf;
}
.form-help {
  margin-top: 4px;
}
.form-help small {
  color: #8c8c8c;
}
.template-manager-content {
  padding: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.template-manager-content .manager-header {
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fafafa;
  flex-shrink: 0;
}
.template-manager-content .manager-header button {
  margin-right: 12px;
}
.template-manager-content app-template-selector {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.template-manager-content nz-spin {
  flex: 1;
  display: flex;
  flex-direction: column;
}
/*# sourceMappingURL=builder-screen.component.css.map */
